import _ from 'lodash';
import { translation } from '@/plugins/i18n';
import { pageConfig } from '@/common/service/page-config';
import store from '@/store';
import { validateAssignLicense } from '@/apis/validate';
import { isEmptyVal } from '@/utils';
import { CouponErrorHandler } from '@/views/config/coupon/helper/error-handler';
import BillingMessageBox from '@/components/common/message-box';
import { isPaidAccount } from '@/common/utils';
import { BILLING_CYCLE } from '@/common/constants';
import { plansof } from '@/utils/chain';

const PAY_BY_CHECK_UPGRADE_QUERY_KEY = 'payByCheckUpgrade';

export const beforeCheckForCoupon = async () => {
  // check for JW Migration unAssign license check
  await preCheckForPayByCheckUpgradeAssignInfo();
};

const popUpMessageWithAssign = (options = {}) => {
  return BillingMessageBox.alert(options?.errorMessage, translation('billing.common.can_not_continue'));
};

export const preCheckForPayByCheckUpgradeAssignInfo = async () => {
  const { fromCampaignLink, orderDataPayload } = store.getters;
  const isPayByCheckForUpgrade = _.get(pageConfig, PAY_BY_CHECK_UPGRADE_QUERY_KEY, false);

  // from campaign link & jw migrate (pay by check account migrate to paid account)
  if (fromCampaignLink && isPayByCheckForUpgrade) {
    await validateAssignLicense(orderDataPayload)
      .catch((result) => {
        popUpMessageWithAssign(result);
        return Promise.reject();
      });
  }

  return Promise.resolve();
};

export const beforeInitPageCheckForCoupon = () => {
  const { couponErrorResult, accountType } = pageConfig || {};

  // For coupon error
  if (isPaidAccount(accountType) && !isEmptyVal(couponErrorResult)) {
    store.commit('setGlobalErrorState', true);

    const instance = new CouponErrorHandler(couponErrorResult);
    const message = instance.getErrorMsgWithErrorCode();

    BillingMessageBox.alert(
      message,
      translation('billing.coupon.not_eligible_dialog_title'),
      {
        dangerouslyUseHTMLString: true,
        confirmButtonText: translation('billing.success.confirmation.view_my_plan'),
        beforeClose: (action) => {
          if (action === 'confirm') {
            window.location.href = '/billing';
          }
        },
      },
    );

    return Promise.reject();
  }

  return Promise.resolve();
};

export const checkCurrentIsEditA2MCases = () => {
  const getters = store.getters;
  const currentEditPlan = getters.currentEditPlan;
  if (currentEditPlan?.billing_cycle === BILLING_CYCLE.ANNUAL) {
    const monthlyPlan = plansof(getters.getSelectedPlans).type(currentEditPlan?.type).monthly().get(0);
    return !isEmptyVal(monthlyPlan);
  }

  return false;
};
